(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var busy = false;

    var getDrawer = function () { return document.querySelector('[data-cart-drawer]'); };

    var openDrawer = function () {
      var d = getDrawer();
      if (!d) return;
      d.hidden = false;
      document.body.classList.add('is-locked');
    };
    var closeDrawer = function () {
      var d = getDrawer();
      if (!d) return;
      d.hidden = true;
      if (!document.querySelector('.mnav:not([hidden]), .srch:not([hidden])')) {
        document.body.classList.remove('is-locked');
      }
    };

    var syncCount = function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
    };

    var refresh = function (open) {
      return fetch(root + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-body]');
          var current = document.querySelector('[data-cart-drawer-body]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            syncCount(parseInt(fresh.getAttribute('data-cart-count-value'), 10) || 0);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
          if (open) openDrawer();
        });
    };

    var addToCart = function (form) {
      if (busy) return;
      busy = true;
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = btn.dataset.adding || label; }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(serialize(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(true); })
        .catch(function () {})
        .finally(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    };

    var serialize = function (form) {
      var data = { items: [] };
      var item = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name) return;
        if (el.name === 'id') item.id = el.value;
        else if (el.name === 'quantity') item.quantity = parseInt(el.value, 10) || 1;
        else if (el.name.indexOf('properties') === 0) { /* skip for brevity */ }
      });
      item.quantity = item.quantity || 1;
      data.items.push(item);
      return data;
    };

    var changeLine = function (key, quantity) {
      if (busy) return;
      busy = true;
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(false); })
        .catch(function () {})
        .finally(function () { busy = false; });
    };

    /* Open from header cart icon */
    document.addEventListener('cart:open', function () { refresh(true); });

    /* Delegated events (survive innerHTML refresh) */
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn && closeBtn.closest('[data-cart-drawer]')) { closeDrawer(); return; }

      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var input = line.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input && input.value, 10) || 1;

      if (e.target.closest('[data-cart-plus]')) changeLine(key, qty + 1);
      else if (e.target.closest('[data-cart-minus]')) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-cart-remove]')) changeLine(key, 0);
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-add-to-cart]');
      if (!form) {
        var candidate = e.target.closest('form[action*="/cart/add"]');
        if (candidate && !candidate.hasAttribute('data-no-drawer')) form = candidate;
      }
      if (!form) return;
      e.preventDefault();
      addToCart(form);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart-page').forEach(function (root) {
      var updateButton = root.querySelector('[data-cart-update]');
      if (!updateButton) return;
      var submitUpdate = function () {
        var form = updateButton.closest('form');
        if (!form) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit(updateButton);
        else updateButton.click();
      };
      root.querySelectorAll('[data-cart-qty]').forEach(function (wrap) {
        var input = wrap.querySelector('[data-cart-qty-input]');
        wrap.querySelector('[data-cart-qty-minus]').addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          submitUpdate();
        });
        wrap.querySelector('[data-cart-qty-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 0) + 1;
          submitUpdate();
        });
        input.addEventListener('change', submitUpdate);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var sort = document.querySelector('[data-coll-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');

    if (header) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      onScroll();
      document.addEventListener('scroll', onScroll, { passive: true });
    }

    /* --- Ticker swaps to the cart drawer's free-shipping message once the cart has items --- */
    var ticker = document.querySelector('[data-ticker]');
    var syncTicker = function () {
      if (!ticker) return;
      var body = document.querySelector('[data-cart-drawer-body]');
      var count = body ? parseInt(body.getAttribute('data-cart-count-value'), 10) || 0 : 0;
      var message = body && body.querySelector('[data-ship-message]');
      var text = count > 0 && message ? message.textContent.trim() : '';
      ticker.querySelector('[data-ticker-ship]').textContent = text;
      ticker.classList.toggle('is-cart', text !== '');
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncTicker);
    else syncTicker();
    document.addEventListener('cart:updated', syncTicker);

    /* --- Overlay helper (focus trap, Escape, scroll lock) --- */
    var lastFocus = null;
    var openOverlay = function (el, trigger) {
      if (!el) return;
      lastFocus = trigger || document.activeElement;
      el.hidden = false;
      document.body.classList.add('is-locked');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var focusable = el.querySelector('input, button, a');
      if (focusable) setTimeout(function () { focusable.focus(); }, 40);
      el.__trigger = trigger;
    };
    var closeOverlay = function (el) {
      if (!el || el.hidden) return;
      el.hidden = true;
      if (!document.querySelector('.mnav:not([hidden]), .srch:not([hidden]), [data-cart-drawer]:not([hidden])')) {
        document.body.classList.remove('is-locked');
      }
      var trigger = el.__trigger;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    var mobileNav = document.querySelector('[data-mobile-nav]');
    var search = document.querySelector('[data-search]');

    document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openOverlay(mobileNav, btn); });
    });
    document.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeOverlay(mobileNav); });
    });
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openOverlay(search, btn); });
    });
    document.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeOverlay(search); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeOverlay(mobileNav);
        closeOverlay(search);
      }
    });

    /* --- Cart icon opens the cart drawer (handled globally) --- */
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (document.querySelector('[data-cart-drawer]')) {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      });
    });

    /* --- Predictive search --- */
    if (search) {
      var input = search.querySelector('[data-search-input]');
      var results = search.querySelector('[data-search-results]');
      var money = function (cents) {
        try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'DKK' }); }
        catch (e) { return (cents / 100).toFixed(2); }
      };
      var debounce = function (fn, ms) {
        var t; return function () { var a = arguments; clearTimeout(t); t = setTimeout(function () { fn.apply(null, a); }, ms); };
      };
      var render = function (data) {
        var out = '';
        var p = (data.resources && data.resources.results && data.resources.results.products) || [];
        var a = (data.resources && data.resources.results && data.resources.results.articles) || [];
        var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
        p.forEach(function (item) {
          var img = item.featured_image && item.featured_image.url ? '<img src="' + item.featured_image.url + '" alt="" loading="lazy">' : '<span class="srch__glyph">S</span>';
          out += '<a href="' + item.url + '">' + img + '<span class="srch__text"><strong>' + item.title + '</strong><em>' + money(item.price) + '</em></span></a>';
        });
        a.forEach(function (item) {
          out += '<a href="' + item.url + '"><span class="srch__glyph">A</span><span class="srch__text"><strong>' + item.title + '</strong></span></a>';
        });
        pages.forEach(function (item) {
          out += '<a href="' + item.url + '"><span class="srch__glyph">P</span><span class="srch__text"><strong>' + item.title + '</strong></span></a>';
        });
        results.innerHTML = out || '<p class="srch__none">' + (input.dataset.none || '') + '</p>';
      };
      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,article,page&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }, 220);
      input.addEventListener('input', run);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.bundlepage [data-quantity]').forEach(function (qty) {
      var input = qty.querySelector('[data-qty-input]');
      qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.pdp').forEach(function (root) {
      var mainImage = root.querySelector('[data-product-main-image]');
      var thumbs = root.querySelectorAll('[data-product-thumb]');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-image-src');
          if (!src || !mainImage) return;
          mainImage.src = src;
          mainImage.alt = btn.getAttribute('data-image-alt') || '';
          thumbs.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      var select = root.querySelector('[data-variant-select]');
      var priceEl = root.querySelector('[data-add-price]');
      if (select && priceEl) {
        select.addEventListener('change', function () {
          var opt = select.selectedOptions && select.selectedOptions[0];
          if (opt && opt.getAttribute('data-variant-price')) priceEl.textContent = opt.getAttribute('data-variant-price');
        });
      }

      var qty = root.querySelector('[data-quantity]');
      if (qty) {
        var input = qty.querySelector('[data-qty-input]');
        qty.querySelector('[data-qty-minus]').addEventListener('click', function () {
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        });
        qty.querySelector('[data-qty-plus]').addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 1) + 1;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
